import { FC, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { refactorPermissions } from '@lhb/func';
import { ImportModalValuesProps } from '@/views/fishtogether/pages/chancepointmanage/ts-config';
import styles from '../index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Operate from '@/common/components/Others/V2Operate';
import ImportChancePointHistoryModal from '../ImportChancePointHistoryModal';

/**
 * 机会创建抽屉-头部
 * @description
 * @demo
 */
const Component:FC<{
  id,
  chancepointAlias,
  importPermission,
  onSearch?,
  setRefreshCurrentDrawer,
}> = ({
  id,
  chancepointAlias,
  importPermission,
  onSearch,
  setRefreshCurrentDrawer,
}) => {

  /* state */
  const [importModalProps, setImportModalProps] = useState<ImportModalValuesProps>({ visible: false });

  /* hooks */

  /* methods */

  const methods = useMethods({

    /** 处理导入 */
    handleImport() {
      setImportModalProps({ visible: true, id });
    },

  });

  return (<>
    <V2Title
      text={chancepointAlias}
      className={styles.title}
      extra={
        <div className='mr-40'>
          <V2Operate
            operateList={refactorPermissions(importPermission)?.map((item) => ({
              ...item,
              type: 'primary',
            }))}
            onClick={(btn) => methods[btn.func]()}
          />
        </div>
      }
    />

    {/* 导入审批表弹窗 */}
    <ImportChancePointHistoryModal
      visible={importModalProps.visible}
      importChancePointId={id}
      closeHandle={() => {
        setImportModalProps({ visible: false });
      }}
      confirmHandle={() => {
        setImportModalProps({ visible: false });
        onSearch && onSearch({});
        setRefreshCurrentDrawer((val) => val + 1);
      }}
    />

  </>);
};

export default Component;
